(function () {
  const sections = document.querySelectorAll('[data-fqb-section]');
  if (!sections.length) return;

  const reduceMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;

  const wait = (ms) => new Promise((resolve) => window.setTimeout(resolve, ms));

  async function typeLines(section) {
    const lines = section.querySelectorAll('[data-fqb-type]');
    if (!lines.length) return;

    for (const line of lines) {
      const fullText = line.getAttribute('data-fqb-text') || line.textContent || '';
      line.textContent = '';
      line.classList.add('is-typing');

      for (let index = 0; index < fullText.length; index += 1) {
        line.textContent = fullText.slice(0, index + 1);
        await wait(38);
      }

      line.classList.remove('is-typing');
      line.classList.add('is-typed');
      await wait(180);
    }
  }

  sections.forEach((section) => {
    if (reduceMotion) return;
    section.setAttribute('data-fqb-ready', '');
  });

  if (reduceMotion) return;

  const observer = new IntersectionObserver(
    (entries) => {
      entries.forEach((entry) => {
        if (!entry.isIntersecting) return;
        entry.target.setAttribute('data-fqb-visible', '');
        if (!entry.target.hasAttribute('data-fqb-typed')) {
          entry.target.setAttribute('data-fqb-typed', '');
          window.setTimeout(() => {
            typeLines(entry.target);
          }, 260);
        }
        observer.unobserve(entry.target);
      });
    },
    {
      threshold: 0.24,
      rootMargin: '0px 0px -10% 0px'
    }
  );

  sections.forEach((section) => observer.observe(section));
})();
